import { render } from "./NotificationMessage.vue?vue&type=template&id=0d6cced5&scoped=true"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"

import "./NotificationMessage.vue?vue&type=style&index=0&id=0d6cced5&scoped=true&lang=scss"
import "./NotificationMessage.vue?vue&type=style&index=1&id=0d6cced5&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6cced5"]])

export default __exports__